import React from "react";

import {
  Alert,
  LoadingIndicator,
  SettingsPageContainer,
  useToast,
} from "../../../components";
import {
  FeatureName,
  useOrgGoogleMeetSettingsQuery,
  useUpdateOrganizationGoogleMeetMutation,
} from "../../graphql";
import { useHasFeatureAccess } from "../../hooks/useHasFeatureAccess";
import GoogleMeetSettingsForm from "./GoogleMeetSettingsForm";

const GoogleMeetSettings: React.FC = () => {
  const toast = useToast();

  const settingsQuery = useOrgGoogleMeetSettingsQuery();
  const orgGoogleMeetSettings = settingsQuery.data?.currentUser?.organization;

  const [updateGoogleMeetSettings, { loading: mutationLoading }] =
    useUpdateOrganizationGoogleMeetMutation();

  const hasVirtualOnsiteAccess = useHasFeatureAccess(
    FeatureName.VirtualOnsiteSplitting
  );

  if (!orgGoogleMeetSettings) {
    return (
      <SettingsPageContainer heading="Google Meet notetaker">
        {settingsQuery.loading && <LoadingIndicator mt="25%" />}
        {settingsQuery.error && (
          <Alert
            mb={8}
            status="error"
            description={settingsQuery.error.message}
          />
        )}
      </SettingsPageContainer>
    );
  }

  return (
    <SettingsPageContainer heading="Google Meet notetaker">
      <GoogleMeetSettingsForm
        organizationName={orgGoogleMeetSettings.name}
        googleMeetEnabled={orgGoogleMeetSettings.googleMeetEnabled}
        googleMeetSendCancelRecordingChatMessage={
          orgGoogleMeetSettings.googleMeetSendCancelRecordingChatMessage
        }
        googleMeetRecordingDisclaimer={
          orgGoogleMeetSettings.googleMeetRecordingDisclaimer
        }
        googleMeetRecordingDisclaimerType={
          orgGoogleMeetSettings.googleMeetRecordingDisclaimerType
        }
        googleMeetDisplayImageBucketPath={
          orgGoogleMeetSettings.googleMeetDisplayImageBucketPath
        }
        defaultDisclaimer={
          orgGoogleMeetSettings.notetakerRecorderDisclaimerDefault
        }
        defaultDisplayName={orgGoogleMeetSettings.googleMeetDisplayName}
        showVirtualOnsiteSetting={hasVirtualOnsiteAccess}
        virtualOnsiteEnabled={
          orgGoogleMeetSettings.virtualOnsiteEnabledGoogleMeet
        }
        isLoading={settingsQuery.loading || mutationLoading}
        error={settingsQuery.error ?? undefined}
        onSubmit={(formData) =>
          updateGoogleMeetSettings({ variables: formData })
            .then((result) => {
              if (result.data?.updateOrganizationGoogleMeet?.organization) {
                toast({
                  status: "success",
                  title: "Google Meet Settings",
                  description: "Saved!",
                });
              }
            })
            .catch((error) => {
              toast({
                status: "error",
                title: "Google Meet Settings",
                description:
                  error?.message ?? "There was a problem - please try again",
              });
            })
        }
      />
    </SettingsPageContainer>
  );
};

export default GoogleMeetSettings;
